const emoji_icons = [
	'😃', '🙁', '😇', '😂', '🥸', '😸', '💯', '❤️',
	'🎁', '🍕', '💩', '👍', '🥑', '🌈', '🦄', '🌻'
];
